import { SerialPort }	from "webserial";
import Modbus 			from "../modbus_with_scheduler.js";

export default class Bus_Modbus extends Modbus {
  constructor() {    
    super();      
  }
  async initialize(...args) {
    let serialPort = new SerialPort();
    
    /* wrap the serialPort object into Modbus */
    this.wrap(serialPort);    

    await this.open(...args);
  }  
  async update() {    
  }   
  get type() {
    return "bus";
  }  
  toJSON() {
      return({
        type: this.type
      });
  }  
}